import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { MICRO_TEXT_MAX_CHARACTERS } from 'constants/logic';
import Input from '../Input/Input';

import './ContactsInput.scss';

const ContactsInput = ({ icon, staticText, ...props }) => (
  <Input
    {...props}
    className="contacts-input"
    inputClassName={classNames('contacts-input__input', {
      'contacts-input__input--with-static-text': !!staticText,
    })}
    maxLength={MICRO_TEXT_MAX_CHARACTERS}>
    {icon && <span className="contacts-input__icon">{icon}</span>}
    {staticText && <span className="contacts-input__static">{staticText}</span>}
  </Input>
);

ContactsInput.propTypes = {
  icon: PropTypes.node,
  staticText: PropTypes.string,
};

export default ContactsInput;
